var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6562 5.61719C15.9297 5.34375 15.9297 4.93359 15.6562 4.66016L11.7188 0.941406C11.3086 0.558594 10.625 0.832031 10.625 1.43359V3.40234C6.60547 3.40234 3.40625 4.19531 3.40625 8.13281C3.40625 9.69141 4.36328 11.25 5.42969 12.043C5.75781 12.2891 6.22266 11.9883 6.11328 11.5781C4.99219 7.85938 6.66016 6.90234 10.625 6.90234V8.84375C10.625 9.44531 11.3086 9.71875 11.7188 9.33594L15.6562 5.61719ZM10.625 11.1406V13H1.875V4.25H3.24219C3.32422 4.25 3.43359 4.22266 3.48828 4.16797C3.89844 3.73047 4.36328 3.40234 4.88281 3.12891C5.18359 2.96484 5.07422 2.5 4.74609 2.5H1.4375C0.699219 2.5 0.125 3.10156 0.125 3.8125V13.4375C0.125 14.1758 0.699219 14.75 1.4375 14.75H11.0625C11.7734 14.75 12.375 14.1758 12.375 13.4375V11.0312C12.375 10.7852 12.1289 10.6484 11.9102 10.7031C11.7461 10.7852 11.4453 10.8398 11.2812 10.8398C11.1992 10.8398 11.0625 10.8125 10.9805 10.8125C10.7891 10.7852 10.625 10.9219 10.625 11.1406Z",
    fill: "#1A86E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.74b3ba34.svg";
export { ForwardRef as ReactComponent };